import { ModalCardData } from '../types';

// Login Modal Data
export const LOGIN_MODAL_CARDS: ModalCardData[] = [
  {
    image:
      'https://assets.clear.in/cleartax/images/1698320751_group1814218805.png',
    title: 'Expert Assisted ITR Filing',
    subTitle: 'To access your ITR filling',
    listIcon:
      'https://assets1.cleartax-cdn.com/cleartax/images/1659964837_largecheckmark.svg',
    lists: [
      'Top-Tier Tax Experts',
      'Live Video Assistance',
      '24-hour Filing Guarantee',
      'Maximized Refund',
    ],
    buttonText: 'Hire a Tax Expert',
    buttonUrl:
      '/s/pricing?ref=/s/v2/homev2/&utm_ref=/s/v2/homev2/_pages_navbar',
  },
  {
    image:
      'https://assets.clear.in/cleartax/images/1698320547_group1814218808.png',
    title: 'Large Enterprises',
    subTitle: 'To access your business solutions',
    listIcon:
      'https://assets1.cleartax-cdn.com/cleartax/images/1659964837_largecheckmark.svg',
    lists: ['GST', 'Max ITC', 'Accounts Payable e‑Invoicing & More'],
    buttonText: 'Request a demo',
    buttonUrl:
      '/s/contact-sales?ref=/s/v2/homev2/&utm_ref=/s/v2/homev2/_pages_navbar',
  },
];
